import { useEffect, useState } from 'react';

const FRC_DEAL_URL = process.env.REACT_APP_FRC_DEAL_URL || "https://frc-deal.vercel.app";
const FRC_DEAL_OFFLINE_URL = `${FRC_DEAL_URL}/offline`;

const LAST_WARMED_KEY = "frcDealLastWarmed";
const WARM_COOLDOWN_MS = 12 * 60 * 60 * 1000; // don't re-fetch on every app load
const UNMOUNT_AFTER_MS = 8000; // enough time for the iframe's own SW to register + start precaching

/** Silently warms FRC Deal's offline mode while Osprey is online, so its
 *  service worker (registered on FRC Deal's own origin — see
 *  web/src/components/ServiceWorkerRegister.tsx there) is already
 *  registered and precached by the time someone opens Games > FRC Deal
 *  without a connection, instead of only warming on that first manual
 *  visit. Renders a hidden iframe, briefly, and nothing else. */
function FrcDealPreload({ online }) {
    const [warming, setWarming] = useState(false);

    useEffect(() => {
        if (!online) return;
        const last = Number(localStorage.getItem(LAST_WARMED_KEY) || 0);
        if (Date.now() - last < WARM_COOLDOWN_MS) return;
        setWarming(true);
    }, [online]);

    useEffect(() => {
        if (!warming) return;
        const timer = setTimeout(() => setWarming(false), UNMOUNT_AFTER_MS);
        return () => clearTimeout(timer);
    }, [warming]);

    if (!warming) return null;

    return (
        <iframe
            src={FRC_DEAL_OFFLINE_URL}
            title="FRC Deal offline warm-up"
            style={{ display: 'none' }}
            aria-hidden="true"
            onLoad={() => localStorage.setItem(LAST_WARMED_KEY, String(Date.now()))}
        />
    );
}
export default FrcDealPreload;
